import { parametricToPolygon } from "./parametric";
import { rcFrame, rcKeyPolygon, rcToPolygon } from "./rcCantilever";
import type { PropertyLine, WallInput } from "../types/input";

type Geometry = WallInput["geometry"];

/**
 * Parsel sınırının kesitteki x konumu (burun ucu x = 0 sistemi). Sınır gövde yüzünden `clearance` uzakta: betonarmede gövde
 * ön/arka yüzünün tabandaki noktası, taşta gövdenin (temel bloğu üstü) burun/topuk köşesi. Sınır yoksa ya da serbest çokgen
 * kesitte (gövde yüzü tanımsız) null.
 */
export function propertyLineX(g: Geometry, line: PropertyLine | undefined): number | null {
  if (!line) return null;
  const c = line.clearance;
  if (g.mode === "rc-cantilever") {
    const f = rcFrame(g);
    return line.side === "front" ? f.xStemFront - c : f.xStemBack + c;
  }
  if (g.mode !== "parametric") return null;
  const bodyFront = g.foundation?.toeExtension ?? 0;
  return line.side === "front" ? bodyFront - c : bodyFront + g.steps[g.steps.length - 1]!.bottomThickness + c;
}

/** Kesitin parsel sınırını aşma miktarı (m, yatay): > 0 → sınır dışına taşan genişlik, ≤ 0 → içeride (pay). */
export function propertyLineExcess(g: Geometry, line: PropertyLine | undefined): number | null {
  const x = propertyLineX(g, line);
  if (x === null || !line) return null;
  const poly = g.mode === "rc-cantilever" ? [...rcToPolygon(g), ...(rcKeyPolygon(g) ?? [])] : g.mode === "parametric" ? parametricToPolygon(g) : [];
  const xs = poly.map((p) => p.x);
  return line.side === "front" ? x - Math.min(...xs) : Math.max(...xs) - x;
}
